import { option } from "fp-ts";
import { Option } from "fp-ts/lib/Option.js";

// Helper function to safely get attribute values
export const getAttributeValue = (
  elm: Element,
  attrName: string
): Option<string> => {
  return option.fromNullable(elm.attributes.getNamedItem(attrName)?.value);
};
